module.exports = __webpack_public_path__ + "img/courier-rlcarriers.463afc86.svg";